var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorrowFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF3030",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M21.3 11a5 5 0 1 1-5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1A7A7",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M19.55 7.333h4.334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E44E4E",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m8.387 21.798 1.004-.422a7.66 7.66 0 0 1 4.46-.451l1.37.272a4.228 4.228 0 0 1 2.663 1.754v0m-9.497 4.168.122-.03a6.47 6.47 0 0 1 4.032.323v0a6.471 6.471 0 0 0 2.507.505h.16a7.26 7.26 0 0 0 4.013-1.21l4.481-2.973c.32-.212.513-.57.513-.955v0c0-.564-.411-1.045-.97-1.132l-.373-.058a1.589 1.589 0 0 0-.711.05l-4.277 1.312m0 0-4.14 1.241"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowFee);
export default __webpack_public_path__ + "static/media/borrowFee.0b27e6c2f42d0f4ee13df165c961e4c6.svg";
export { ForwardRef as ReactComponent };